import { render, staticRenderFns } from "./WebPlayerLivePage.vue?vue&type=template&id=10815b8d&"
import script from "./WebPlayerLivePage.vue?vue&type=script&lang=js&"
export * from "./WebPlayerLivePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10815b8d')) {
      api.createRecord('10815b8d', component.options)
    } else {
      api.reload('10815b8d', component.options)
    }
    module.hot.accept("./WebPlayerLivePage.vue?vue&type=template&id=10815b8d&", function () {
      api.rerender('10815b8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/live/components/WebPlayerLivePage.vue"
export default component.exports